import { render, staticRenderFns } from "./SarcopeniaMeasurements.vue?vue&type=template&id=506e0f64&scoped=true"
import script from "./SarcopeniaMeasurements.vue?vue&type=script&lang=js"
export * from "./SarcopeniaMeasurements.vue?vue&type=script&lang=js"
import style0 from "./SarcopeniaMeasurements.vue?vue&type=style&index=0&id=506e0f64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506e0f64",
  null
  
)

export default component.exports